import ILocalStorage from './Interfaces/ILocalStorage';

class LocalStorage implements ILocalStorage {
    public estimatedBandwidth: number = null;
    public volumeLevel: number = null;
    public volumeMuted: boolean = null;
}

export default LocalStorage;